import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=6b1c7324&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=6b1c7324&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1c7324",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b1c7324')) {
      api.createRecord('6b1c7324', component.options)
    } else {
      api.reload('6b1c7324', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=6b1c7324&scoped=true&", function () {
      api.rerender('6b1c7324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2nnrJQgp8g5lq/JS/comp/SearchFilterTokens.vue"
export default component.exports